module.exports = __webpack_public_path__ + "static/pensjonat-zima_thumb-7a1f9feabdf92ad4c5e515b2cacd3b2e.jpg";